module.exports = "<h2>LOGIN</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-login/page-login.component.html
// module id = ./src/app/components/pages/page-login/page-login.component.html
// module chunks = main